import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowupFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "6",
    fill: "none",
    viewBox: "0 0 12 6",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.719 6a.7.7 0 0 1-.521-.199A.64.64 0 0 1 0 5.338q0-.067.223-.46L5.237.303q.172-.158.357-.23A1.1 1.1 0 0 1 6 0a1.1 1.1 0 0 1 .406.073q.185.072.357.23l5.014 4.575q.105.094.163.211.06.117.06.25a.63.63 0 0 1-.198.464.7.7 0 0 1-.521.197z"
  }));
}
var IcArrowupFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowupFillNomargin));

export { IcArrowupFillNomargin as I };
